import script from "./LoadingScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=6c54bd41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c54bd41"]])

export default __exports__